









import { createTracker, finderSessionId, visitorId } from 'uhs-finder.metrics';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;


function stamp(form, key, value) {
  const name = `properties[${key}]`;
  let input = form.querySelector(`input[name="${CSS.escape(name)}"]`);

  if (!input) {
    input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    form.appendChild(input);
  }

  input.value = value;
}

export function applyAttribution(search) {

  const form = document.querySelector('form[action*="/cart/add"]');
  if (!form) return;



  const visitor = visitorId();
  if (visitor && UUID.test(visitor)) stamp(form, '_uhs_vid', visitor);
  else form.querySelector('input[name="properties[_uhs_vid]"]')?.remove();

  const sessionId = finderSessionId(search);
  if (!sessionId) return;

  stamp(form, '_uhs_fs', sessionId);
}



const METRICS_ENDPOINT = '/apps/uhs/finder-event';





export function trackAddedToCart(search) {
  const sessionId = finderSessionId(search);
  if (!sessionId) return;

  createTracker(METRICS_ENDPOINT, sessionId)('added_to_cart');
}


let submitListener = null;




export function initAttribution(search) {
  applyAttribution(search);

  if (submitListener) document.removeEventListener('submit', submitListener, true);





  submitListener = event => {
    applyAttribution(search);
    if (event.target?.closest?.('form[action*="/cart/add"]')) trackAddedToCart(search);
  };

  document.addEventListener('submit', submitListener, true);
}

initAttribution(window.location.search);
